import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FileUploadButtonTheme } from 'studio-components';

export type FileEventTarget = EventTarget & { files: FileList };

@Component({
  selector: 'studio-file-upload-button',
  templateUrl: './file-upload-button.component.html',
  styleUrls: ['./file-upload-button.component.scss'],
})
export class FileUploadButtonComponent {
  @ViewChild('fileInput') input: ElementRef<HTMLInputElement>;

  @Input() public theme: FileUploadButtonTheme = 'light';
  @Input() public accept: string;
  @Input() public uniqueId: string;
  @Input() public label: string;
  @Input() public disabled = false;
  @Input() public showIcon = true;
  @Input() public showFileName = false;

  @Output() public fileChanged = new EventEmitter<FileList>();
  @Output() public fileCleared = new EventEmitter<void>();

  public filename: string;

  get displayFilename() {
    return this.showFileName && Boolean(this.filename);
  }

  fileSelected(target: HTMLInputElement) {
    this.filename = target.files[0]?.name;
    this.fileChanged.emit(target.files);
  }

  public clearFileClicked() {
    this.clearFile();
    this.fileCleared.emit();
  }

  public clearFile() {
    this.input.nativeElement.value = null;
    this.filename = null;
  }
}
